const API = {
  LOG_IN: "/checkin/login",
  REGISTER: "/checkin/register",
  RESET_PASSWORD: "/checkin/reset-password",
  FORGOT_PASSWORD: "/checkin/forgot-password",
  PROFILE: "/checkin/me",
  SLACK_LINK: "/slack/link",
  GET_ANALYTICS: "/checkin/client-analytics",
  STATUS: "/checkin/status",
  QUESTIONS: "/checkin/questions",
  ANSWERS: "/checkin/answers",
  EARNED: "/checkin/earning",
  GET_DEPARTMENTS: "/company_departments_by_check_in",
  GET_COUNTRIES: "/country",
  GET_RESOURCES: "/resource/get-by-pillar",
  GET_ARTICLE: "/resource/article",
  GET_VIDEO: "/resource/video",
  GET_PODCAST: "/resource/podcast",
  GET_MUSIC: "/resource/calm-music",
  GET_JOURNALS: "/checkin/journals",
  UPDATE_JOURNAL: '/checkin/update_journal',
  CREATE_JOURNAL: '/checkin/add_journal',
  DELETE_JOURNAL: '/checkin/delete_journal',
  ASK_AI_BOT: '/checkin/ask-ai-bot',
  GET_TRENDS: '/checkin/trends-analytics',
  GET_SENTIMENT_ANALYSIS: '/checkin/sentiment-analytics',
  GET_TEXT_ANALYSIS: '/checkin/text-analytics',
  GET_ACTIVITY_LEADERBOARD: '/checkin/activity-leaderboard',
  LOW_PILLARS: '/checkin/get-lowest-pillars',
  GET_MOST_DECREASED_PILLAR: '/checkin/get-most-decreased-pillar',
  GET_NOTIFICATIONS: '/checkin/notifications',
  WHATSAPP_SEND_OTP: '/whatsapp/check-in/send-code',
  WHATSAPP_VERIFY_OTP: '/whatsapp/check-in/verify',
  TEAMS_RESOLVE_URL: '/teams/check-in/resolve-url',
  VERIFY_EMAIL: '/checkin/verify-email',
  VERIFY_EMAIL_LINK: '/checkin/verify-email-link',
  RESEND_VERIFY_EMAIL: '/checkin/resend-verify-email',
};

export default API;
